(function () {
  'use strict';
  if (customElements.get('dio-privacy-choices')) return;

  class DioPrivacyChoices extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-privacy-form]');
      this.opener = this.querySelector('[data-privacy-open]');
      this.status = this.querySelector('[data-privacy-status]');
      this.options = this.querySelector('[data-privacy-options]');
      this.saveButton = this.querySelector('[data-privacy-save]');
      this.rejectButton = this.querySelector('[data-privacy-reject]');
      this.announcement = this.querySelector('[data-privacy-announcement]');
      this.controller = new AbortController();
      const listener = { signal: this.controller.signal };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-privacy-open]');
        if (trigger) this.open(trigger);
      }, listener);
      const refresh = () => Promise.resolve().then(() => { if (this.isConnected) this.refreshTriggers(); });
      document.addEventListener('shopify:section:load', refresh, listener);
      document.addEventListener('shopify:section:unload', refresh, listener);
      this.querySelector('[data-privacy-close]').addEventListener('click', () => this.dialog.close(), listener);
      this.dialog.addEventListener('close', () => {
        clearTimeout(this.timer);
        const opener = this.returnFocus && this.returnFocus.isConnected ? this.returnFocus : this.opener;
        if (opener.isConnected) opener.focus();
      }, listener);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.save();
      }, listener);
      this.form.addEventListener('change', () => { this.edited = true; }, listener);
      this.rejectButton.addEventListener('click', () => {
        this.form.querySelectorAll('[data-privacy-purpose]').forEach(input => { input.checked = false; });
        this.edited = true;
        this.save();
      }, listener);
      const consent = window.DioConsent;
      if (consent) this.unsubscribe = consent.subscribe(value => {
        if (this.dialog.open && !this.edited && !this.saving) this.populate(value);
      });
      this.refreshTriggers();
    }

    refreshTriggers() {
      const buttons = Array.from(document.querySelectorAll('[data-privacy-open]'));
      buttons.forEach(button => { button.disabled = false; });
      // The layout's fallback keeps footerless pages usable. No control moves.
      this.querySelector('.dio-privacy-entry').hidden = buttons.some(button => !this.contains(button));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.unsubscribe) this.unsubscribe();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }

    open(opener) {
      if (this.dialog.open) return;
      this.returnFocus = opener || this.opener;
      this.sequence = (this.sequence || 0) + 1;
      if (typeof this.dialog.showModal !== 'function') {
        this.announcement.textContent = 'Your browser cannot open privacy choices. Contact info@dioconnect.com for help.';
        return;
      }
      this.edited = false;
      this.saving = false;
      this.announcement.textContent = '';
      this.setBusy(true);
      this.status.textContent = 'Loading your choices…';
      this.dialog.showModal();
      this.querySelector('h2').focus();
      const consent = window.DioConsent;
      if (consent) {
        consent.initialize();
        const current = consent.current();
        if (current) this.populate(current);
      }
      clearTimeout(this.timer);
      if (this.options.disabled) this.timer = setTimeout(() => {
        if (this.dialog.open && this.options.disabled) this.status.textContent = 'Your choices could not load. Please refresh the page and try again, or contact info@dioconnect.com.';
      }, 6000);
    }

    populate(value) {
      clearTimeout(this.timer);
      this.form.elements.analytics.checked = value.analytics;
      this.form.elements.marketing.checked = value.marketing && value.sale;
      this.form.elements.preferences.checked = value.preferences;
      this.setBusy(false);
      this.status.textContent = '';
    }

    setBusy(busy) {
      this.options.disabled = busy;
      this.saveButton.disabled = busy;
      this.rejectButton.disabled = busy;
      this.form.setAttribute('aria-busy', String(busy));
    }

    save() {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (this.saving || this.options.disabled) return;
      if (!api || typeof api.setTrackingConsent !== 'function') {
        this.status.textContent = 'Your choices could not be saved. Please refresh the page and try again.';
        return;
      }
      const values = {
        analytics: this.form.elements.analytics.checked,
        marketing: this.form.elements.marketing.checked,
        preferences: this.form.elements.preferences.checked,
        sale_of_data: this.form.elements.marketing.checked
      };
      this.saving = true;
      const sequence = this.sequence;
      this.setBusy(true);
      this.status.textContent = 'Saving your choices…';
      clearTimeout(this.timer);
      let complete = false;
      const failure = () => {
        complete = true;
        clearTimeout(this.timer);
        if (!this.isConnected) return;
        this.saving = false;
        this.setBusy(false);
        this.status.textContent = 'Your choices could not be saved. Please try again.';
      };
      this.timer = setTimeout(failure, 10000);
      try {
        // A deliberate visitor action is the only writer. Shopify persists it.
        api.setTrackingConsent(values, error => {
          if (complete) return;
          if (error || typeof api.currentVisitorConsent !== 'function') return failure();
          const recorded = api.currentVisitorConsent();
          if (Object.keys(values).some(key => recorded[key] !== (values[key] ? 'yes' : 'no'))) return failure();
          complete = true;
          clearTimeout(this.timer);
          if (window.DioConsent) window.DioConsent.initialize();
          if (!this.isConnected) return;
          this.saving = false;
          this.setBusy(false);
          this.announcement.textContent = 'Privacy choices saved.';
          if (this.sequence === sequence) this.dialog.close();
        });
      } catch (error) { failure(); }
    }
  }
  customElements.define('dio-privacy-choices', DioPrivacyChoices);
})();
